import { LocalizedString } from "../../presentation";
export class TranslatedParser {
    constructor(localizationProvider) {
        this.localizationProvider = localizationProvider;
    }
    parse(value) {
        return new LocalizedString(this.localizationProvider, value);
    }
}
